<template>
  <div>
    <Widget>
      <div
        v-if="data_laporan?.status_laporan === 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'"
        class="card bg-warning mb-4"
      >
        <div class="card-body p-0">
          <h4 class="card-title m-3">Catatan Penolakan</h4>
          <div class="m-3">
            <div v-html="data_laporan.catatan_laporan_tahunan"></div>
          </div>
        </div>
      </div>

      <form-tabs ref="formTabs" :value="progress - 1" @change="updateProgress">
        <form-tab title="Identitas">
          <formIdentitas ref="form1" />
        </form-tab>

        <form-tab title="Kemajuan Perizinan">
          <formKemajuanPerizinan ref="form2" />
        </form-tab>

        <form-tab title="Realisasi Pemanfaatan Ruang Laut">
          <formRealisasiPemanfaatanRuangLaut ref="form3" />
        </form-tab>

        <form-tab title="Pemenuhan Kewajiban">
          <formPemenuhanKewajiban ref="form4" />
        </form-tab>

        <template #footer>
          <div class="d-flex justify-content-between" style="padding: 14px 20px 14px 20px">
            <b-button @click="btnBack" id="btn_back" v-if="progress === 1" variant="danger" style="color: white">
              Kembali
            </b-button>
            <b-button id="btn_previews" v-else @click="prevForm" variant="primary">
              <i class="fa fa-caret-left" /> Tab Sebelumnya
            </b-button>

            <b-button
              id="btn_next"
              @click="nextForm"
              variant="primary"
              style="float: right"
              :hidden="!(progress !== 4)"
            >
              Tab Selanjutnya <i class="fa fa-caret-right" />
            </b-button>
            <div id="btn_finish" style="float: right" :hidden="progress !== 4 || page_pemenuhan !== 16">
              <template v-if="!is_selesai">
                <b-button @click="nextForm()" variant="success"> Simpan </b-button>
              </template>
              <template v-else>
                <b-button @click="$router.push('/app/penilaian-pelaksanaan/pelaku-usaha')" variant="secondary">
                  Kembali
                </b-button>
              </template>
            </div>
          </div>
        </template>
      </form-tabs>
    </Widget>
  </div>
</template>

<style scoped>
:deep(.input-units) {
  position: relative;
  overflow: hidden;
}

:deep(.input-units .text-units) {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 0px;
  margin: 0.375rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0);
}

:deep(.input-units .text-units span:first-child) {
  visibility: hidden;
}
</style>

<script>
import Vue from 'vue'
import Widget from '@/components/Widget/Widget'
import FormTabs from '@/components/FormTabs/FormTabs.vue'
import FormTab from '@/components/FormTabs/FormTab.vue'
import formIdentitas from './formIdentitas.vue'
import formKemajuanPerizinan from './formKemajuanPerizinan.vue'
import formRealisasiPemanfaatanRuangLaut from './formRealisasiPemanfaatanRuangLaut.vue'
import formPemenuhanKewajiban from './formPemenuhanKewajiban.vue'
import { Validator } from 'vee-validate'
import Swal from 'sweetalert2'
import axios from 'axios'
import dayjs from 'dayjs'

export default {
  components: {
    Widget,
    FormTabs,
    FormTab,
    formIdentitas,
    formKemajuanPerizinan,
    formRealisasiPemanfaatanRuangLaut,
    formPemenuhanKewajiban,
  },
  data() {
    return {
      progress: 1,
      id_laporan_perizinan_berusaha: [],
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      is_selesai: false,
      data_laporan: null,
      page_pemenuhan: 1,
    }
  },
  provide() {
    return {
      inj_is_selesai: () => this.is_selesai,
      setIsSelesai: (val) => {
        this.is_selesai = val
      },
      inj_data_laporan: () => this.data_laporan,
      setDataLaporan: (val) => {
        this.data_laporan = val
      },
      inj_page_pemenuhan: () => this.page_pemenuhan,
      setPagePemenuhan: (val) => {
        this.page_pemenuhan = val
      },
    }
  },
  mounted() {
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
          email: () => 'Email tidak valid',
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
  methods: {
    updateProgress(index) {
      Vue.set(this, 'progress', index + 1)
    },

    prevForm() {
      this.$refs.formTabs.navigateTo(this.progress - 2)
      setTimeout(() => {
        $('html,body').scrollTop(0)
      }, 100)
    },

    async nextForm(status = '') {
      const forms = { 1: this.$refs.form1, 2: this.$refs.form2, 3: this.$refs.form3, 4: this.$refs.form4 }
      const currentForm = forms[this.progress]
      if (!currentForm || !(await currentForm.nextForm())) return

      if (this.progress < 4) {
        // maju ke tab berikutnya (index 0-based = progress)
        this.$refs.formTabs.navigateTo(this.progress)
      } else if (!status) {
        this.$router.push('/app/penilaian-pelaksanaan/pelaku-usaha')
      } else if (await this.submitLaporanTahunan(status)) {
        this.$router.push('/app/penilaian-pelaksanaan/pelaku-usaha')
      }

      setTimeout(() => {
        $('html,body').scrollTop(0)
      }, 500)
    },

    async submitLaporanTahunan(status) {
      const result = await Swal.fire({
        icon: 'question',
        title: 'Simpan Data?',
        text: 'Apakah Anda yakin ingin menyimpan data penilaian pelaksanaan ini?',
        showCancelButton: true,
        confirmButtonText: 'Ya, Simpan',
        cancelButtonText: 'Batal',
      })
      if (!result.isConfirmed) return false

      return await axios
        .post(
          this.baseapiPengendalian + `api/laporan_tahunan/${this.$route.query.id_laporan}`,
          { status_laporan: status, tanggal_submit_laporan: dayjs(new Date()).format('YYYY-MM-DD') },
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )
        .then((res) => {
          Swal.fire('Berhasil', 'Berhasil menyimpan data penilaian pelaksanaan.', 'success')
          return true
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Gagal menyimpan data penilaian pelaksanaan.', 'error')
          return false
        })
    },

    btnBack() {
      this.$router.push('/app/penilaian-pelaksanaan/pelaku-usaha')
    },
  },
}
</script>
